import { render, staticRenderFns } from "./topic-reg-manage.vue?vue&type=template&id=7ca34a48&scoped=true"
import script from "./topic-reg-manage.vue?vue&type=script&lang=js"
export * from "./topic-reg-manage.vue?vue&type=script&lang=js"
import style0 from "./topic-reg-manage.vue?vue&type=style&index=0&id=7ca34a48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca34a48",
  null
  
)

export default component.exports